import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';

import ArrowDownIcon from '../../../../../images/icons/misc/Arrow-Down.svg';
import InPlayIcon from '../../../../../images/betslip/UI_goinginplay-grey.svg';
import ThirdPartyIcon from '../../../../../images/betslip/ThirdPartyBet-grey.svg';
import DFIcon from '../../../../../images/betslip/DF-grey.svg';
import PromoIcon from '../../../../../images/betslip/UI_promos-grey.svg';
import ZeroIcon from '../../../../../images/betslip/icon-mbzero.svg';

import style from './IconKeys.module.scss';

const IconKeys = () => {
  const [collapsible, setCollapsable] = useState(true);

  const iconKeysContainer = classNames({
    [style.iconKeysContainer]: true,
    [style['iconKeysContainer--collapsible']]: collapsible,
  });

  return (
    <div className={iconKeysContainer}>
      <div className={style.iconKeysTitle} role="button" onClick={() => setCollapsable(!collapsible)}>
        Icon Key
        <ArrowDownIcon />
      </div>
      {!collapsible && (
        <div className={style.collapsableContainer}>
          <div className={style.containerRow}>
            <div className={style.symbolContainer}><DFIcon /></div>
            <span>This bet has had a deduction factor applied due to a withdrawn horse.
              <Link
                className={style.eventName}
                to={'/page/rules_and_regulations/sports-rules/#heading-horse-racing'}
              >What is a deduction factor?</Link>
            </span>
          </div>
          <div className={style.containerRow}>
            <div className={style.symbolContainer}><ThirdPartyIcon /></div>
            <span>This bet was placed via a 3rd party site.</span>
          </div>
          <div className={style.containerRow}>
            <div className={style.symbolContainer}><PromoIcon /></div>
            <span>
              {'This bet was placed using a Free Bet - the stake will not be returned for winning bets.'}
            </span>
          </div>
          <div className={style.containerRow}>
            <div className={style.symbolContainer}><InPlayIcon /></div>
            <span>Unmatched portions of this bet will be kept when the event goes In-Play.</span>
          </div>
          <div className={style.containerRow}>
            <div className={style.symbolContainer}><ZeroIcon className={style.iconColor} /></div>
            <span>This is a Matchbook Zero Bet.</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default IconKeys;
